import { createContext, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_LOCALE } from '../features/localization/localization';

const LocalizationContext = createContext(null);

export function LocalizationProvider({ children }) {
  const [locale, setLocale] = useState(DEFAULT_LOCALE);

  const _setLocale = (newLocale) => {
    if (newLocale === locale) return;
    setLocale(newLocale);
  };

  const value = { locale, setLocale: _setLocale };

  return <LocalizationContext.Provider value={value}>{children}</LocalizationContext.Provider>;
}

LocalizationProvider.propTypes = {
  children: PropTypes.element.isRequired
};

export function useLocalization() {
  return useContext(LocalizationContext);
}